import { useCallback } from 'react';

import { ChevronDown, DownloadIcon } from 'lucide-react';

import {
  Button,
  Icon,
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarTrigger,
  Spinner,
} from '@/_components';

import { useGetLabelFourSixGenerationMutation, useGetSelfLabelGenerationMutation } from '../../apis';

export function GenerateLabelButton({ id }: { id: string }) {
  const { isPending: isFourSixPending, mutateAsync: mutateFourSixAsync } = useGetLabelFourSixGenerationMutation(id);
  const { isPending: isSelfPending, mutateAsync: mutateSelfAsync } = useGetSelfLabelGenerationMutation(id);

  const handleFourSixClick = useCallback(async () => {
    const res = await mutateFourSixAsync();
    if (res.data) {
      window.open(res.data.pdf_url, '_blank');
    } else {
      console.log('Error downloading  pdf');
    }
  }, [mutateFourSixAsync]);

  const handleSelfClick = useCallback(async () => {
    const res = await mutateSelfAsync();
    if (res.data) {
      window.open(res.data.pdf_url, '_blank');
    } else {
      console.log('Error downloading  pdf');
    }
  }, [mutateSelfAsync]);

  return (
    <Menubar className="-mt-2 -mr-4">
      <MenubarMenu>
        <MenubarTrigger>
          <Button
            tag="div"
            showLoader={isFourSixPending || isSelfPending}
            size="sm"
            as={isFourSixPending || isSelfPending ? 'outline' : 'link'}
            className="dark:text-primary"
            iconRight={ChevronDown}
          >
            Generate Label
          </Button>
        </MenubarTrigger>
        <MenubarContent align="end">
          <MenubarItem onClick={handleFourSixClick} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icon icon={DownloadIcon} className="size-4" />
              <span>Label 4 x 6&quot;</span>
            </div>
            {isFourSixPending && <Spinner size="xs" className="ml-2" />}
          </MenubarItem>

          <MenubarItem onClick={handleSelfClick} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <Icon icon={DownloadIcon} className="size-4" />
              <span>Shelf Tag Label 1 x 2.125&quot;</span>
            </div>
            {isSelfPending && <Spinner size="xs" className="ml-2" />}
          </MenubarItem>
        </MenubarContent>
      </MenubarMenu>
    </Menubar>
  );
}
